import { http_api } from "../../leadg-api";
const search = (request, config) => {
    let url = `contacts-search/search?page=${request.page}&pageSize=${request.pageSize}`;
    if (request.search)
        url += `&search=${encodeURIComponent(request.search)}`;
    if (request.sortField)
        url += `&sortField=${encodeURIComponent(request.sortField)}`;
    if (request.sortOrder)
        url += `&sortOrder=${request.sortOrder}`;
    return http_api.get(url, config);
};
// Create a new contact and link it to the selected lead (create-or-link-by-composite
// handled server-side).
const create = (input) => {
    return http_api.post("contacts-search/create", input);
};
// Global edit of the contact entity's own fields (applies to every lead it's linked to).
const update = (input) => {
    return http_api.put("contacts-search/update", input);
};
// Link an already-existing contact to a lead (no contact-data mutation).
const link = (input) => {
    return http_api.post("contacts-search/link", input);
};
// Unlink a contact from ONE lead (soft-deletes the junction; contact survives).
const unlink = (input) => {
    return http_api.post("contacts-search/unlink", input);
};
// Delete a contact entirely (soft-delete + unlink from every lead, transactional).
const remove = (contactId) => {
    return http_api.delete(`contacts-search/${contactId}`);
};
const getById = (contactId) => {
    return http_api.get(`contacts-search/${contactId}`);
};
// contactId excludes leads already linked to that contact, so it can't be linked twice.
const getLeadsDropdown = (contactId) => {
    let url = "contacts-search/leads-dropdown";
    if (contactId)
        url += `?contactId=${encodeURIComponent(contactId)}`;
    return http_api.get(url);
};
const ContactSearchApi = {
    search,
    create,
    update,
    link,
    unlink,
    remove,
    getById,
    getLeadsDropdown,
};
export default ContactSearchApi;
